import { ShareboxDashboardTable } from "modules/ShareboxDashboard/components";

export const ShareboxDashboard = () => <ShareboxDashboardTable />;
